import {Outlet} from '@github-ui/react-router'

/**
 * Parent route for the data-router `issues` app. Every leaf (labels, milestone
 * new/index/edit) owns its own `RepoIssuesPageLayout`, so this parent is a pure
 * passthrough — it only exists to host the shared issues-layout route query that
 * the leaves read via `useRouteQuery(issuesLayoutRoute, ...)`.
 *
 * Keep it a passthrough: wrapping `Outlet` in any element, even a bare context provider, makes
 * `saved-views` fetch on first paint. Its test is the guard, and names neither this file nor why.
 */
export function IssuesLayout() {
  return <Outlet />
}
